import React, { useState, useEffect } from "react";
import "./BackToTop.scss";

const BackToTop = () => {
  const [isVisible, setIsVisible] = useState(false);

  // Show button when page is scrolled down
  const toggleVisibility = () => {
    if (window.pageYOffset > 300) {
      setIsVisible(true);
    } else {
      setIsVisible(false);
    }
  };

  // Set the top scroll position
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth"
    });
  };

  useEffect(() => {
    window.addEventListener("scroll", toggleVisibility);
    return () => window.removeEventListener("scroll", toggleVisibility);
  }, []);

  return (
    <div className={`back-to-top ${isVisible ? "visible" : ""}`}>
      <button onClick={scrollToTop} aria-label="Back to top">
        <span>Back to Top</span>
        <i className="fas fa-chevron-up"></i>
      </button>
    </div>
  );
};

export default BackToTop;
